import React from 'react';
import { FaChevronLeft, FaChevronRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import { generatePageNumbers } from '../config/pagination';
import '../styles/Pagination.css';

/**
 * Composant de pagination réutilisable
 * @param {object} props - Propriétés du composant
 * @returns {JSX.Element} Composant de pagination
 */
const Pagination = ({
  totalItems,
  totalPages,
  currentPage,
  pageSize,
  startIndex,
  endIndex,
  hasNextPage,
  hasPreviousPage,
  isFirstPage,
  isLastPage,
  onPageChange,
  onPageSizeChange,
  config = {},
  className = ''
}) => {
  // Ne pas afficher la pagination s'il y a une seule page ou moins
  if (!totalItems || totalPages <= 1) {
    return null;
  }

  const pageNumbers = generatePageNumbers(currentPage, totalPages, config.maxPageButtons);
  
  return (
    <div className={`pagination-container ${className}`}>
      {/* Informations de pagination */}
      {config.showInfo !== false && (
        <div className="pagination-info">
          Affichage de {startIndex} à {endIndex} sur {totalItems} résultats
        </div>
      )}
      
      <div className="pagination-controls">
        {/* Sélecteur de taille de page */}
        {config.enableSizeSelector !== false && onPageSizeChange && (
          <div className="page-size-selector">
            <label htmlFor="pageSize">Afficher :</label>
            <select
              id="pageSize"
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              className="page-size-select"
            >
              {config.pageSizeOptions?.map(size => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
            <span>par page</span>
          </div>
        )}
        
        {/* Navigation de pagination */}
        <div className="pagination-navigation">
          {/* Première page */}
          <button
            className="pagination-btn"
            onClick={() => onPageChange(1)}
            disabled={isFirstPage}
            title="Première page"
          >
            <FaAngleDoubleLeft />
          </button>
          
          {/* Page précédente */}
          <button
            className="pagination-btn"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={!hasPreviousPage}
            title="Page précédente"
          >
            <FaChevronLeft />
          </button>
          
          {/* Numéros de pages */}
          <div className="page-numbers">
            {pageNumbers.map(pageNum => (
              <button
                key={pageNum}
                className={`page-number ${currentPage === pageNum ? 'active' : ''}`}
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            ))}
          </div>
          
          {/* Page suivante */}
          <button
            className="pagination-btn"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={!hasNextPage}
            title="Page suivante"
          >
            <FaChevronRight />
          </button>
          
          {/* Dernière page */}
          <button
            className="pagination-btn"
            onClick={() => onPageChange(totalPages)}
            disabled={isLastPage}
            title="Dernière page"
          >
            <FaAngleDoubleRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;